import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { deDE } from '@mui/x-date-pickers/locales';
import config from './config';

const configuration = config[process.env.REACT_APP_CLIENT || 'wbg'];

const x = createTheme(
  {
    palette: {
      primary: {
        main: configuration.color,
      },
      secondary: {
        main: '#58585A',
        light: '#F1F2F2',
      },
    },
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            wordBreak: 'keep-all',
          },
        },
      },
      MuiCardHeader: {
        styleOverrides: {
          root: {
            boxShadow: '0px 0px 8px #0000004d',
            background: '#efefef 0% 0% no-repeat padding-box',
          },
          title: {
            textAlign: 'center',
          },
        },
      },
    },
  },
  deDE,
);
const theme = responsiveFontSizes(x);

export default theme;
